<div mat-dialog-content class="synchro-modal">
  <mat-spinner></mat-spinner>
  <div class="label">
    <p>
      {{ "sync.sync" | translate }}
    </p>
    <div class="icon">
      <mat-icon color="primary" svgIcon="bookmark"></mat-icon>
      <mat-icon color="primary" svgIcon="notes"></mat-icon>
      <mat-icon color="primary" svgIcon="agenda"></mat-icon>
      <mat-icon color="primary" svgIcon="shopping-basket"></mat-icon>
    </div>
  </div>
</div>
